import { useContext } from "react";
import { CancelacionMasivaContext } from "../../../context";
import { ResultTableCancelacion, SectionSelector, UploadPolizas } from "./components";

export const CancelacionMasiva55 = () => {
  const { selected, setSelected, resumenListo } = useContext(
    CancelacionMasivaContext
  );

  const returnToMain = () => setSelected(undefined);

  if (resumenListo) return <ResultTableCancelacion />;
  if (selected === "archivo")
    return <UploadPolizas returnToMain={returnToMain} />;
  return <SectionSelector />;
};
